export default __webpack_public_path__ + "static/media/barcode.0e30ab29.svg";